import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from '@chakra-ui/react';
import PhoneNumbers from './voice-agent/PhoneNumbers';
import BatchCall from './voice-agent/BatchCall';
import CallHistory from './voice-agent/CallHistory';
import Analytics from './voice-agent/Analytics';
import VoiceAgentKnowledgeBase from './voice-agent/KnowledgeBase';
import VoiceAgentBilling from './voice-agent/Billing';

const VoiceAgent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  // Map routes to tab indices
  const routeToTabIndex = {
    '/admin/voice-agent/knowledge-base': 0,
    '/admin/voice-agent/phone-numbers': 1,
    '/admin/voice-agent/batch-call': 2,
    '/admin/voice-agent/call-history': 3,
    '/admin/voice-agent/analytics': 4,
    '/admin/voice-agent/billing': 5,
  };

  // Map tab indices to routes
  const tabIndexToRoute = {
    0: '/admin/voice-agent/knowledge-base',
    1: '/admin/voice-agent/phone-numbers',
    2: '/admin/voice-agent/batch-call',
    3: '/admin/voice-agent/call-history',
    4: '/admin/voice-agent/analytics',
    5: '/admin/voice-agent/billing',
  };

  // Update tab index when route changes
  useEffect(() => {
    const path = location.pathname;
    const index = routeToTabIndex[path];
    if (index !== undefined) {
      setTabIndex(index);
    } else {
      if (location.pathname === '/admin/voice-agent' || location.pathname === '/admin/voice-agent/') {
        navigate(tabIndexToRoute[0], { replace: true });
      }
    }
  }, [location.pathname, navigate, routeToTabIndex, tabIndexToRoute]);

  const handleTabsChange = (index) => {
    setTabIndex(index);
    const route = tabIndexToRoute[index];
    if (route) {
      navigate(route);
    }
  };

  return (
    <Box>
      <VStack spacing={6} align="stretch">
        <Heading size="lg">Voice Agent</Heading>
        <Text color="gray.500">
          Manage your voice agents, monitor performance, and handle calls efficiently.
        </Text>

        <Box
          bg={bgColor}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          overflow="hidden"
        >
          <Tabs
            variant="enclosed"
            colorScheme="purple"
            index={tabIndex}
            onChange={handleTabsChange}
          >
            <TabList>
              <Tab>Knowledge Base</Tab>
              <Tab>Phone Numbers</Tab>
              <Tab>Batch Call</Tab>
              <Tab>Call History</Tab>
              <Tab>Analytics</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <VoiceAgentKnowledgeBase />
              </TabPanel>
              <TabPanel>
                <PhoneNumbers />
              </TabPanel>
              <TabPanel>
                <BatchCall />
              </TabPanel>
              <TabPanel>
                <CallHistory />
              </TabPanel>
              <TabPanel>
                <Analytics />
              </TabPanel>
              <TabPanel>
                <VoiceAgentBilling />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </VStack>
    </Box>
  );
};

export default VoiceAgent;
